import { DOCUMENT_UPLOADING_START, DOCUMENT_UPLOADING_END } from '../actions/AppAction'

const initState = {
  isUploading: false,
}

export default (state = initState, action) => {
  switch (action.type) {
    case DOCUMENT_UPLOADING_START:
      return Object.assign({}, state, {
        isUploading: true,
      })
    case DOCUMENT_UPLOADING_END:
      return Object.assign({}, state, {
        isUploading: false,
      })
    case 'RESET':
      return initState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AppReducer.js